/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowaskwhen3Inputs */

const en_aiflowaskwhen3 = /** @type {(inputs: Aiflowaskwhen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When does the event take place?`)
};

const de_aiflowaskwhen3 = /** @type {(inputs: Aiflowaskwhen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann findet das Event statt?`)
};

/**
* | output |
* | --- |
* | "When does the event take place?" |
*
* @param {Aiflowaskwhen3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowaskwhen3 = /** @type {((inputs?: Aiflowaskwhen3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowaskwhen3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowaskwhen3(inputs)
	return de_aiflowaskwhen3(inputs)
});
export { aiflowaskwhen3 as "aiFlowAskWhen" }